const HomeOffSvg = () => {
  return (
    <svg data-name="グループ 4" xmlns="http://www.w3.org/2000/svg" width="25.34" height="27.127">
      <g data-name="グループ 2">
        <path
          data-name="パス 36"
          d="M24.875 10.734L13.65.384a1.444 1.444 0 00-1.96 0L.465 10.734A1.448 1.448 0 000 11.797v.651h25.34v-.651a1.448 1.448 0 00-.465-1.063z"
          fill="none"
        />
      </g>
      <g data-name="グループ 3" fill="none" strokeMiterlimit="10">
        <g data-name="パス 37">
          <path d="M11.69.383L.465 10.733A1.448 1.448 0 000 11.796v13.111a2.15 2.15 0 002.057 2.22h5.739a1.445 1.445 0 001.445-1.445v-6.851a1.445 1.445 0 011.446-1.446h3.966a1.445 1.445 0 011.446 1.446v6.851a1.445 1.445 0 001.445 1.445h5.739a2.15 2.15 0 002.057-2.22V11.796a1.448 1.448 0 00-.465-1.063L13.65.383a1.444 1.444 0 00-1.96 0z" />
          <path
            d="M12.67 1.52L1.5 11.819v13.088c0 .384.26.72.557.72h5.684v-6.796a2.95 2.95 0 012.946-2.946h3.966a2.95 2.95 0 012.946 2.946v6.796h5.684c.297 0 .557-.336.557-.72V11.819l-11.17-10.3m0-1.52c.352 0 .703.129.98.384l11.225 10.35c.296.274.465.659.465 1.063v13.111c0 1.221-.926 2.22-2.057 2.22h-5.739a1.445 1.445 0 01-1.445-1.445v-6.85c0-.8-.647-1.447-1.446-1.447h-3.966c-.799 0-1.446.647-1.446 1.446v6.85c0 .799-.647 1.446-1.445 1.446H2.057C.926 27.127 0 26.128 0 24.907V11.796c0-.404.169-.79.465-1.063L11.69.383c.277-.255.629-.383.98-.383z"
            fill="#8c8c8c"
          />
        </g>
        <path data-name="線 23" stroke="#8c8c8c" strokeWidth="1.5" d="M25.34 12.447H0" />
      </g>
    </svg>
  )
}

export default HomeOffSvg
